import types from './mutation-types';
import ItemService from '@/services/item-service';
import BidNumberService from '@/services/bid-number-service';

const actions = {
	getBid({ commit }, { itemId, pendingBidId }) {

		commit(types.FETCH_BID_START);

		return ItemService.getPendingBid(itemId, pendingBidId)
			.then(bid => commit(types.FETCH_BID_SUCCESS, bid))
			.catch(error => commit(types.FETCH_BID_ERROR, error.response.data));

	},
	getItem({ commit }, { itemId }) {

		commit(types.FETCH_ITEM_START);

		return ItemService.getOne(itemId)
			.then(item => commit(types.FETCH_ITEM_SUCCESS, item))
			.catch(error => commit(types.FETCH_ITEM_ERROR, error.response.data));

	},
	createBid({ commit }, { itemId, bid }) {

		commit(types.CREATE_BID_START);

		return ItemService.createPendingBid(itemId, bid)
			.then(bid => commit(types.CREATE_BID_SUCCESS, bid))
			.catch(error => commit(types.CREATE_BID_ERROR, error.response.data));

	},
	updateBid({ commit }, { itemId, pendingBidId, bid }) {

		commit(types.UPDATE_BID_START);

		return ItemService.updatePendingBid(itemId, pendingBidId, bid)
			.then(bid => commit(types.UPDATE_BID_SUCCESS, bid))
			.catch(error => commit(types.UPDATE_BID_ERROR, error.response.data));

	},
	deleteBid({ commit }, { itemId, pendingBidId }) {

		commit(types.DELETE_BID_START);

		return ItemService.deletePendingBid(itemId, pendingBidId)
			.then(response => commit(types.DELETE_BID_SUCCESS))
			.catch(error => {

				const commitError = (error.response) ? error.response.data : error;
				commit(types.DELETE_BID_ERROR, commitError)

			});
	},
	getPersonBidNumbers({ commit }, { auctionId, params }) {
		commit(types.FETCH_BID_NUMBERS_START);

		return BidNumberService.getPersonBidNumbers(auctionId, params)
			.then(response => commit(types.FETCH_BID_NUMBERS_SUCCESS, response))
			.catch(error => commit(types.FETCH_BID_NUMBERS_ERROR, error.response.data));
	},
	resetAll({ commit }) {
		commit(types.RESET_ALL);
	}
}

export default actions


// WEBPACK FOOTER //
// ./src/store/modules/pending-bid-form/actions.js